var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2547_39333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 7.13633V3.04544C1 2.50296 1.2155 1.98269 1.5991 1.5991C1.9827 1.2155 2.50296 1 3.04545 1H7.13636M12.8636 1H16.9545C17.497 1 18.0173 1.2155 18.4009 1.5991C18.7845 1.98269 19 2.50296 19 3.04544V7.13633M19 12.8637V16.9546C19 17.497 18.7845 18.0173 18.4009 18.4009C18.0173 18.7845 17.497 19 16.9545 19H12.8636M7.13636 19H3.04545C2.50296 19 1.9827 18.7845 1.5991 18.4009C1.2155 18.0173 1 17.497 1 16.9546V12.8637M13.6818 9.99985C13.6818 12.0333 12.0334 13.6816 9.99996 13.6816C7.96655 13.6816 6.31815 12.0333 6.31815 9.99985C6.31815 7.96645 7.96655 6.31805 9.99996 6.31805C12.0334 6.31805 13.6818 7.96645 13.6818 9.99985Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2547_39333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArea);
export default __webpack_public_path__ + "static/media/area.485899da9a05b90a7a3ef8c163856225.svg";
export { ForwardRef as ReactComponent };